import React from 'react';

import {
  makeStyles,
  Paper,
  Grid,
  Container,
} from '@material-ui/core';

import Summary from './components/Summary';
import Request from './components/Request';

import { injectIntl } from 'react-intl';

import styles from './styles';
const useStyles = makeStyles(styles);

function NewRequest(props) {
  const classes = useStyles();
  
  return (
    <Container className={classes.container}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Summary />
        </Grid>
        <Grid item xs={12}>
          <Paper>
            <Container>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Container className={classes.containerForm}>
                    <Request />
                  </Container>
                </Grid>
              </Grid>
            </Container>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default injectIntl(NewRequest);
